import React from 'react';

const HowToPlayContentES: React.FC = () => {
  return (
    <div className="space-y-4 text-gray-700">
      <div className="bg-blue-50 p-4 rounded-2xl">
        <h3 className="font-bold text-blue-800 mb-2">🎯 El Objetivo</h3>
        <p>¡Adivina quién tiene qué número observando cómo actúan!</p>
      </div>

      <div className="bg-green-50 p-4 rounded-2xl">
        <h3 className="font-bold text-green-800 mb-2">👥 Jugadores</h3>
        <p>Necesitas 4-10 jugadores. Una persona será el "adivinador" y los demás obtendrán números secretos del 1-9.</p>
      </div>

      <div className="bg-orange-50 p-4 rounded-2xl">
        <h3 className="font-bold text-orange-800 mb-2">🎭 Cómo Jugar</h3>
        <div className="space-y-2 text-sm">
          <p><strong>1.</strong> El adivinador lee una situación en voz alta</p>
          <p><strong>2.</strong> Todos los demás actúan su reacción basada en su número</p>
          <p><strong>3.</strong> ¡Número 1 = muy calmado, Número 9 = totalmente loco!</p>
          <p><strong>4.</strong> El adivinador observa y trata de descifrar quién tiene qué número</p>
        </div>
      </div>

      <div className="bg-purple-50 p-4 rounded-2xl">
        <h3 className="font-bold text-purple-800 mb-2">🏆 Ganar</h3>
        <p>¡El adivinador obtiene puntos por cada acierto correcto. Luego alguien más se convierte en el nuevo adivinador!</p>
      </div>

      <div className="bg-yellow-50 p-4 rounded-2xl">
        <h3 className="font-bold text-yellow-800 mb-2">💡 Ejemplo</h3>
        <p className="text-sm"><strong>Situación:</strong> "Ves una araña en tu cuarto"</p>
        <p className="text-sm">• Número 1: Mantente calmado, tal vez la ignores</p>
        <p className="text-sm">• Número 9: ¡Grita y corre!</p>
      </div>
    </div>
  );
};

export default HowToPlayContentES;